import { takeLatest } from '@redux-saga/core/effects';
import { SagaIterator } from '@redux-saga/core';
import { setTagCampaignActive } from 'domains/search/model/reducer';
import { setTagCampaignActiveDefault } from 'domains/search/model/actions';
import { fetcherPartnerBalanceWorker } from 'domains/search/model/sagas/workers';
import {
  onToggleStatusCampaignSaga,
  workerFetchCampaignsStatisticsSaga,
  workerFetchCampaignsStatisticsWeekSaga,
  workerCreateCampaignSaga,
  workerFetchCampaignsSaga,
  workerSearchTagsCampaign,
  sortCampaignListWorker,
  filterCampaignsTagsWorker,
  fetchCampaignsListModalSagaWorker,
  setCampaignsFilterWorker,
  changeStatusGroupCampaignsWorker,
  copyCampaignsToOtherClientWorker,
  doubleCampaignsWorker,
  exportItemsToExcelWorker,
  workerFetchCampaignsTranslationSaga,
  workerFetchChartStatisticsSaga,
  fetcherPartnerStatisticFieldListWorker,
  setPartnerStatisticFieldsWorker,
  fetchTotalListStatWorker,
  fetchVendorLinkDataSagaWorker,
  workerSetCampaignsIcon,
  workerClearCampaignsIcon,
  fetchMassEditCampaignWorker,
  workerFetchSimilarOrdCampaignsSaga,
  fetchCopyCampPartnersListWorker,
  setStatusesInCampaignsCreativesWorker,
} from './workers';
import {
  createCampaignAction,
  fetchCampaigns,
  fetchCampaignsStatistic,
  fetchCampaignsStatisticWeek,
  setCampaignsFilter,
  setListSort,
  setToggleStatusCampaign,
  fetchCampaignsTranslation,
  fetchChartStatistic,
  fetchCampaignsTotal,
  fetchCampaignsIcons,
  setCampaignsIcon,
  clearCampaignsIcon,
  fetchMassEditCampaign,
  fetchSimilarOrdCampaigns,
  fetchCopyCampPartnersList,
  fetchSetStatusesInCampaignsCreatives,
} from '../reducer';
import {
  changeGroupCampaigns,
  cloneCampaignsToClient,
  doubleCampaigns,
  exportItemsToExcel,
  fetchCampaignsListModal,
  fetchPartnerBalance,
  fetchStatisticFieldList,
  setPartnerStatisticsFields,
} from '../model/actions';

export default function* watcher(): SagaIterator {
  yield takeLatest(fetchCampaigns, workerFetchCampaignsSaga);
  yield takeLatest(fetchSimilarOrdCampaigns, workerFetchSimilarOrdCampaignsSaga);
  yield takeLatest(fetchCampaignsStatistic, workerFetchCampaignsStatisticsSaga);
  yield takeLatest(fetchChartStatistic, workerFetchChartStatisticsSaga);
  yield takeLatest(
    fetchCampaignsStatisticWeek,
    workerFetchCampaignsStatisticsWeekSaga,
  );
  yield takeLatest(
    fetchCampaignsTranslation,
    workerFetchCampaignsTranslationSaga,
  );
  yield takeLatest(setToggleStatusCampaign, onToggleStatusCampaignSaga);
  yield takeLatest(createCampaignAction, workerCreateCampaignSaga);
  yield takeLatest(setTagCampaignActiveDefault, workerSearchTagsCampaign);
  yield takeLatest(setListSort, sortCampaignListWorker);
  yield takeLatest(setTagCampaignActive, filterCampaignsTagsWorker);
  yield takeLatest(fetchCampaignsListModal, fetchCampaignsListModalSagaWorker);
  yield takeLatest(fetchPartnerBalance, fetcherPartnerBalanceWorker);
  yield takeLatest(
    fetchStatisticFieldList,
    fetcherPartnerStatisticFieldListWorker,
  );
  yield takeLatest(setCampaignsFilter, setCampaignsFilterWorker);
  yield takeLatest(changeGroupCampaigns, changeStatusGroupCampaignsWorker);
  yield takeLatest(cloneCampaignsToClient, copyCampaignsToOtherClientWorker);
  yield takeLatest(doubleCampaigns, doubleCampaignsWorker);
  yield takeLatest(exportItemsToExcel, exportItemsToExcelWorker);
  yield takeLatest(setPartnerStatisticsFields, setPartnerStatisticFieldsWorker);
  yield takeLatest(fetchCampaignsTotal, fetchTotalListStatWorker);
  yield takeLatest(fetchCampaignsIcons, fetchVendorLinkDataSagaWorker);
  yield takeLatest(setCampaignsIcon, workerSetCampaignsIcon);
  yield takeLatest(clearCampaignsIcon, workerClearCampaignsIcon);
  yield takeLatest(fetchMassEditCampaign, fetchMassEditCampaignWorker);
  yield takeLatest(fetchCopyCampPartnersList, fetchCopyCampPartnersListWorker);
  yield takeLatest(fetchSetStatusesInCampaignsCreatives, setStatusesInCampaignsCreativesWorker);
}